<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        rowKey="contractNo"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import { getUserCompanyList } from '@/common/js/util';
  import COM_API from '@/api/masterData/company.js';
  import { mapState } from 'vuex';
  export default {
    name: 'inputTaxDetails',
    mixins: [tableMixins],
    data() {
      return {
        // footerTotalCols:{amount:['contractTotalAmount'],quantity:['productQuantity']},
        query: {
          payableInvoiceCompanyCodeIn: null,
          payableInvoiceDepartmentCodeIn: null,
          invoiceUnitNoIn: null,
          invoiceCode: null,
          purchaseContractNo: null,
          inboundCode: null,
          inboundBatchNo: null,
          payableInvoiceCreateDate: undefined,
          salesContractNo: undefined,
          salesLadingNo: undefined,
          documentCode: undefined,
          payableInvoiceStatusIn: undefined,
          payableInvoiceCreatePersonNoIn: undefined,
          invoiceTypeIn: undefined,
          belongPeriod: undefined,
          postDate: undefined,
          postStatusIn: undefined,
          currencyCodeIn: undefined,
          expenseTypeName: undefined,

          paidAmountStart: undefined,
          paidAmountEnd: undefined,
          contractStatus: null,
          isCreditsale: null,
          shipComplete: null,
        },
        tableData: [],
        load: false,
        columnListDefault: [
          {
            field: 'payableInvoiceCompanyCode',
            title: '公司代码',
            visible: true,
          },
          {
            field: 'payableInvoiceCompanyName',
            title: '公司名称',
            visible: true,
          },
          {
            field: 'payableInvoiceDepartmentCode',
            title: '部门代码',
            visible: true,
          },
          {
            field: 'payableInvoiceDepartmentName',
            title: '部门名称',
            visible: true,
          },
          {
            field: 'documentCode',
            title: '单据编号',
            visible: true,
          },
          {
            field: 'postStatus',
            title: '入账状态',
            visible: true,
          },
          {
            field: 'postDate',
            title: '入账日期',
            visible: true,
          },
          {
            field: 'payableInvoiceCreateDate',
            title: '制单日期',
            visible: true,
          },
          {
            field: 'payableInvoiceCreatePersonName',
            title: '制单人名称',
            visible: true,
          },
          {
            field: 'belongPeriod',
            title: '归属日期',
            width: '100',
            visible: true,
          },
          {
            field: 'invoiceUnitNo',
            title: '开票单位编码',
            width: '100',
            visible: true,
          },
          {
            field: 'invoiceUnitName',
            title: '开票单位名称',
            visible: true,
          },
          {
            field: 'invoiceType',
            title: '发票类型',
            visible: true,
          },
          {
            field: 'invoiceCode',
            title: '发票编号',
            visible: true,
          },
          {
            field: 'NumberOfInvoices',
            title: '发票张数',
            visible: true,
          },
          {
            field: 'currencyName',
            title: '币种',
            visible: true,
          },
          {
            field: 'exchangeType',
            title: '汇率类型',
            visible: true,
          },
          {
            field: 'exchangeRate',
            title: '汇率',
            visible: true,
          },
          {
            field: 'exchangeDate',
            title: '汇率日期',
            visible: true,
          },
          {
            field: 'originalTotalAmount',
            title: '发票头原币总金额',
            visible: true,
          },
          {
            field: 'originalTotalWithoutTaxAmount',
            title: '发票头原币不含税金额',
            visible: true,
          },
          {
            field: 'originalTaxAmount',
            title: '发票头原币税额',
            visible: true,
          },
          {
            field: 'domesticTotalAmount',
            title: '发票头本币总金额',
            visible: true,
          },
          {
            field: 'amountExcludingTaxHeader',
            title: '发票头本币不含税金额',
            visible: true,
          },
          {
            field: 'TaxAmountInFunctionalHeader',
            title: '发票头本币税额',
            visible: true,
          },
          {
            field: 'mark',
            title: '备注',
            visible: true,
          },
          {
            field: 'payableInvoiceStatus',
            title: '单据状态',
            visible: true,
          },
          {
            field: 'payableInvoiceDetailNo',
            title: '应付发票行编号',
            visible: true,
          },
          {
            field: 'expenseGroup',
            title: '费用大类',
            visible: true,
          },
          {
            field: 'expenseTypeName',
            title: '费用类型',
            visible: true,
          },
          {
            field: 'purchaseContractNo',
            title: '采购合同号',
            visible: true,
          },
          {
            field: 'purchaseContractDetailNo',
            title: '采购合同行项目号',
            visible: true,
          },
          {
            field: 'inboundCode',
            title: '业务入库单号',
            visible: true,
          },
          {
            field: 'inboundBatchNo',
            title: '入库批次号',
            visible: true,
          },
          {
            field: 'returnNo',
            title: '退换货单号',
            visible: true,
          },
          {
            field: 'returnDetailNo',
            title: '退换货单行项目号',
            visible: true,
          },
          {
            field: 'productNo',
            title: '商品编码',
            visible: true,
          },
          {
            field: 'productDesc',
            title: '商品描述',
            visible: true,
          },
          {
            field: 'unitName',
            title: '发票单位',
            visible: true,
          },
          {
            field: 'matchInboundQuantity',
            title: '本次匹配入库数量',
            visible: true,
          },
          {
            field: 'inboundUnitPrice',
            title: '入库单价',
            visible: true,
          },
          {
            field: 'inboundExchangeRate',
            title: '入库汇率',
            visible: true,
          },
          {
            field: 'originProvisionalAmount',
            title: '发票头应付占估原币金额',
            visible: true,
          },
          {
            field: 'localProvisionalAmount',
            title: '发票头应付暂估本币金额',
            visible: true,
          },
          {
            field: 'overShippedQuantity',
            title: '溢短装数量',
            visible: true,
          },
          {
            field: 'invoiceQuantity',
            title: '本次收票数量',
            visible: true,
          },
          {
            field: 'invoiceUnitPrice',
            title: '发票单价',
            visible: true,
          },
          {
            field: 'invoiceUnitPrice',
            title: '发票头原币发票差价',
            visible: true,
          },
          {
            field: 'localInvoiceDifferPrice',
            title: '发票头本币发票差价',
            visible: true,
          },
          {
            field: 'amountWithoutTax',
            title: '不含税金额',
            visible: true,
          },
          {
            field: 'taxName',
            title: '税码',
            visible: true,
          },
          {
            field: 'taxRate',
            title: '税率',
            visible: true,
          },
          {
            field: 'taxAmount',
            title: '税额',
            visible: true,
          },
          {
            field: 'totalAmount',
            title: '总额',
            visible: true,
          },
          {
            field: 'AmountExcludingTaxInFunctionalCurrency',
            title: '本币不含税金额',
            visible: true,
          },
          {
            field: 'taxAmountInLocalCurrency',
            title: '本币税额',
            visible: true,
          },
          {
            field: 'salesContractNo',
            title: '销售合同',
            visible: true,
          },
          {
            field: 'salesLadingNo',
            title: '销售提单号',
            visible: true,
          },
          {
            field: 'batchSettleNo',
            title: '批次结算',
            visible: true,
          },
        ],
        personList: [],
        expenseGroupList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        lang: (state) => state.lang.language,
        dict: (state) => state.dict,
      }),
      searchColumns() {
        return [
          {
            type: 'selectMultiple', // 公司：操作人账户下公司
            name: this.$t('contractAgency.company'),
            prop: 'payableInvoiceCompanyCodeIn',
            options: getUserCompanyList(),
          },
          {
            prop: 'payableInvoiceDepartmentCodeIn',
            name: '部门',
            type: 'treeSelect',
            apiUrl: COM_API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            multiple: true,
            clearable: false,
          },
          {
            prop: 'invoiceUnitNoIn', // 开票单位
            name: this.$t('payablesBillList.search.invoiceUnitName'),
            type: 'searchTableSpec',
            searchType: 'supplier',
            isMultiple: false,
          },
          {
            prop: 'invoiceCode',
            name: '发票编号',
            type: 'input',
          },
          {
            prop: 'purchaseContractNo',
            name: '采购合同号',
            type: 'input',
          },
          {
            prop: 'inboundCode',
            name: '入库单号',
            type: 'input',
          },
          {
            prop: 'inboundBatchNo',
            name: '入库批次号',
            type: 'input',
          },
          {
            prop: 'payableInvoiceCreateDate',
            name: '制单日期',
            type: 'daterange',
          },
          {
            prop: 'salesContractNo',
            name: '销售合同号',
            type: 'input',
          },
          {
            prop: 'salesLadingNo',
            name: '销售提单号',
            type: 'input',
          },
          {
            prop: 'documentCode',
            name: '单据编号',
            type: 'input',
          },
          {
            prop: 'payableInvoiceStatusIn',
            type: 'dictSelect',
            name: '单据状态',
            apiData: { dictType: 'invoice_status' },
            multiple: true,
          },
          {
            // 制单人
            type: 'select',
            name: this.$t('receivablesManage.basicInfo.registerCreatePersonNo'),
            prop: 'payableInvoiceCreatePersonNoIn',
            options: this.personList,
            required: true,
            multiple: true,
          },
          {
            type: 'dictSelect',
            prop: 'invoiceTypeIn',
            name: '发票类型',
            apiData: { dictType: 'invoice_type' },
            multiple: true,
          },
          // {
          //   type: "input",
          //   prop: "businessLadingTotalAmountEnd",
          //   name: "金额"
          // },
          {
            prop: 'belongPeriod',
            name: '归属日期',
            type: 'daterange',
          },
          {
            prop: 'postDate',
            name: '入账日期',
            type: 'daterange',
          },
          {
            type: 'dictSelect',
            prop: 'postStatusIn',
            name: '入账状态',
            apiData: { dictType: 'post_status' },
            multiple: true,
          },
          {
            type: 'dictSelect',
            prop: 'currencyCodeIn',
            name: '币种',
            apiData: { dictType: 'SCZX_currency' },
            multiple: true,
          },
          {
            type: 'select',
            prop: 'expenseTypeName',
            name: '费用类型',
            options: this.expenseGroupList,
          },
        ];
      },
    },
    mounted() {
      this.getPerson();
      this.getDictList();
      this.getData();
    },
    methods: {
      getData() {
        this.load = true;
        let params = {
          pageSize: this.$refs.siruiTable.page.pageSize,
          pageNum: this.$refs.siruiTable.page.pageNum,
          ...this.query,
        };
        if (this.query.payableInvoiceCreateDate) {
          params.payableInvoiceCreateDateStart = this.query.payableInvoiceCreateDate[0];
          params.payableInvoiceCreateDateEnd = this.query.payableInvoiceCreateDates[1];
          delete params.payableInvoiceCreateDate;
        }
        if (this.query.belongPeriod) {
          params.belongPeriodStart = this.query.belongPeriod[0];
          params.belongPeriodEnd = this.query.belongPeriod[1];
          delete params.belongPeriod;
        }
        if (this.query.postDate) {
          params.postDateStart = this.query.postDate[0];
          params.postDateEnd = this.query.postDate[1];
          delete params.postDate;
        }
        if (this.query.payableInvoiceDepartmentCodeIn) {
          params.payableInvoiceDepartmentCodeIn =
            this.query.payableInvoiceDepartmentCodeIn.split(',');
        }
        // if(this.query.storageNoIn) {
        //   params.storageNoIn = this.query.storageNoIn.map(item => {return item.storageCode})
        // }
        // if(this.query.productNoIn) {
        //   params.productNoIn = this.query.productNoIn.map(item => {return item.productDetailCode})
        // }
        this.$axios
          .post('/financial/payment/listInputAndOutputTaxDetailsReportByPage', params)
          .then((res) => {
            this.load = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data.list;
              if (this.$refs.siruiTable) {
                this.$refs.siruiTable.setPageTotal(res.data.data.total);
              }
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
      },
      resetBtnClick() {
        this.getData();
      },
      async getPerson() {
        // 制单人
        let res = await this.$baseRequest.getPerson();
        if (res) {
          this.personList = res.map((item) => {
            return {
              value: item.id + '',
              label: item.personName,
            };
          });
        }
      },
      getDictList() {
        // 费用类型
        this.$baseRequest.getExpenseTypeFormat().then((res) => {
          this.expenseGroupList = res;
        });
      },
    },
  };
</script>

<style scoped></style>
